<template>
    <v-app>
        <Drawer current_item="menu_member_list"></Drawer>

        <v-dialog eager v-model="dialog_create_appointment" persistent max-width="1024">
            <DialogCreateAppointment 
                ref="dialog_create_appointment" 
                @onclosed="dialog_create_appointment = false" 
                @onsuccess="dialog_create_appointment = false" 
                :station_code="$route.params.station_code"
                :disabled_step1="true"
            ></DialogCreateAppointment>
        </v-dialog>

        <v-dialog v-model="dialog_edit_member" persistent max-width="800">
            <FragmentCreateMember 
                ref="dialog_edit_member"
                :station_code="$route.params.station_code"
                @onclosed="dialog_edit_member = false" 
                @onsuccess="onSuccessEditMember"
                :edit_member="edit_member"
                :isaddmember="isaddmember"
            ></FragmentCreateMember>
        </v-dialog>

        <v-main class="ml-6 mr-6">

            <v-row align="end" justify="space-between">
            <v-col cols="12" md="8" class="text-md-h4 text-h5" align="left">
                {{ $t('Member_Title') }}
                </v-col>
            <v-col cols="12" md="4" align="left">
                <FragmentSelectStation :station_code="$route.params.station_code" @onchange="onStationChange"></FragmentSelectStation>
            </v-col>
            </v-row>

            <v-divider class="mb-6"></v-divider>

            <v-tabs v-model="tab" class="mb-4">
              <v-tab
                v-for="item in tabs"
                :key="item"
              >
                {{ $t('Member_Tab_' + item) }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item
                v-for="item in tabs"
                :key="item"
              >
                <FragmentSearchMember 
                  v-if="item=='member'"
                  ref="member_list"
                  @onSelectMember="onSelectMember" 
                  @onCreateAppointment="onCreateAppointment" 
                  :station_code="$route.params.station_code"
                  :enableaction="true"
                  @oneditmember="onEditMember"
                ></FragmentSearchMember>

                <FragmentRegistedMember 
                  v-if="item=='registed'"
                  ref="register_list"
                  :station_code="$route.params.station_code"
                  @oneditmember="onEditMember"
                ></FragmentRegistedMember>

                <FragmentCreateMember 
                  v-if="item=='new'"
                  :station_code="$route.params.station_code"
                ></FragmentCreateMember>

              </v-tab-item>
            </v-tabs-items>

            


          </v-main>
    </v-app>
</template>

<script>
import Drawer from '@/components/Drawer.vue'
import FragmentSelectStation from '@/components/Common/FragmentSelectStation.vue'
import FragmentSearchMember from '@/components/Common/FragmentSearchMember.vue'
import FragmentCreateMember from '@/components/Common/FragmentCreateMember.vue'
import DialogCreateAppointment from '@/components/Common/DialogCreateAppointment'
import FragmentRegistedMember from './FragmentRegistedMember'

export default {
  components: {
    Drawer
    ,FragmentSelectStation
    ,FragmentSearchMember
    ,FragmentCreateMember
    ,FragmentRegistedMember
    ,DialogCreateAppointment
  },
  data () {
    return {
      tab : ""
      ,tabs : ['member','registed','new']
      ,dialog_create_appointment : false
      ,dialog_edit_member : false
      ,edit_member : {}
      ,isaddmember : false
    }
  },
  mounted : function () {
  },
  methods : {
    onStationChange(station){
      document.location = station.station_code
    },
    onSelectMember(){

    },
    onEditMember(member,isaddmember=false){
      console.log(isaddmember)
      this.edit_member = member
      this.isaddmember = isaddmember
      if(this.$refs.dialog_edit_member){
        this.$refs.dialog_edit_member.selectMember(member)
      }
      this.dialog_edit_member = true
    },
    onCreateAppointment(member){
      this.dialog_create_appointment = true
      this.$refs.dialog_create_appointment.reset()
      this.$refs.dialog_create_appointment.nextStepOnSelectMember(member)
    },
    onSuccessEditMember(){
      this.dialog_edit_member = false;
      this.$refs.member_list[0].search();
      this.$refs.register_list[0].reload();
    }
  }
}
</script>